import { useState, useEffect } from "react";
import About from "./components/About";
import Hero from "./components/Hero";
import NavBar from "./components/Navbar";
import Features from "./components/Features";
import Story from "./components/Story";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AIChatbot from "./components/AIChatbot";

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [chatbotPrompt, setChatbotPrompt] = useState('');

  // Listen for custom events to open chatbot
  useEffect(() => {
    const handleOpenChatbot = () => {
      setIsChatbotOpen(true);
    };

    const handleOpenChatbotWithPrompt = (event) => {
      setChatbotPrompt(event.detail.prompt);
      setIsChatbotOpen(true);
    };

    window.addEventListener('openChatbot', handleOpenChatbot);
    window.addEventListener('openChatbotWithPrompt', handleOpenChatbotWithPrompt);
    
    return () => {
      window.removeEventListener('openChatbot', handleOpenChatbot);
      window.removeEventListener('openChatbotWithPrompt', handleOpenChatbotWithPrompt);
    };
  }, []);

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden">
      <NavBar />
      <Hero />
      <About />
      <Features />
      <Story />
      <Contact />
      <Footer />
      
      {/* AI Chatbot - rendered at app level */}
      <AIChatbot 
        isOpen={isChatbotOpen} 
        onClose={() => {
          setIsChatbotOpen(false);
          setChatbotPrompt('');
        }}
        initialPrompt={chatbotPrompt}
      />
    </main>
  );
}

export default App;
